import BackendService from './BackendService';

export interface LendingDealerAddress {
  lineOne: string;
  lineTwo: string;
  city: string;
  state: string;
  zip: string;
}

export interface LendingDealerUpdateData {
  name: string;
  timezone: string;
  phone: string;
  reserveEmail: string;
  address: LendingDealerAddress;
}

export interface LendingDealerData {
  name: string;
  timezone: string;
  phone: string;
  reserveEmail: string;
  address: LendingDealerAddress;
  slug?: string;
  bankAccount?: {
    accountHolderName: string;
    accountNumber: string;
    routingNumber: string;
  };
  enabled?: boolean;
  updatedAt?: string;
}

export default class DealershipApiService {
  static async getLendingDealer(
    dealerSlug: string,
  ): Promise<LendingDealerData> {
    return BackendService.get(`/lending/${dealerSlug}`);
  }

  static async updateLendingDealer(
    dealerSlug: string,
    data: LendingDealerUpdateData,
  ): Promise<LendingDealerData> {
    return BackendService.put(`/lending/${dealerSlug}`, { body: data });
  }
}
